import { StyleSheet } from "react-native";
import { formScreen } from "../Styles/formScreen";

export default StyleSheet.create({
  ...formScreen,
  containerForm: {
    flex: 1,
    width: "100%",
    alignItems: "center",
    backgroundColor: "#aa000000",
    paddingBottom: 50,
  },
  textHeader2: {
    fontFamily: "Montserrat",
    color: "#EEE",
    fontSize: 20,
    marginTop: 30,
    alignSelf: "center",
    marginBottom: 4,
    textAlign: "center",
  },
  label: {
    fontFamily: "Montserrat",
    color: "#FFF",
    alignItems: "center",
    paddingLeft: 8,
    fontSize: 20,
  },
  containerRow: {
    flexDirection: "row",
    width: "100%",
    alignItems: "center",
    marginTop: 16,
  },
  dataContainer: {
    padding: 24,
    width: "90%",
    borderRadius: 8,
    backgroundColor: "#FFF",
    marginTop: 24,
  },
  dataProperty: {
    fontSize: 14,
    color: "#F1F1F1",
    fontWeight: "bold",
  },

  dataValue: {
    marginTop: 4,
    fontSize: 15,
    color: "#C1C1C1",
    marginBottom: 16,
  },
});
